import React from 'react';
import _ from 'lodash';

import styles from './Essay.module.scss';
import Label from '../../../../context/Label/Label';
import useLabel from '../../../../context/Label/useLabel';

type EssayProps = {
  question: any;
  tracking: any;
  config: any;
  onChange: Function;
};

function Essay(props: EssayProps) {
  const { question, tracking, config, onChange } = props;
  const { showCorrectAnswer, showYourAnswers } = config;
  const { answer, submitted, answeredCorrectly } = tracking;
  const { plainLabel } = useLabel();

  function handleChange(e: any) {
    const { id, name, value, type } = e.target;
    onChange &&
      onChange(e, {
        id,
        name,
        value,
        type,
        questionId: question.resourceId,
      });
  }

  const _className = [styles.Essay];
  submitted &&
    showYourAnswers &&
    answeredCorrectly &&
    _className.push(styles.Essay__correct);
  submitted &&
    showYourAnswers &&
    !answeredCorrectly &&
    _className.push(styles.Essay__incorrect);

  return (
    <div className={_className.join(' ')}>
      <textarea
        id={question.resourceId}
        name={question.resourceId}
        placeholder={plainLabel('Type your answer here')}
        onChange={handleChange}
        disabled={submitted}
        rows={3}
        maxLength={240}
        defaultValue={submitted ? answer : undefined}
      />

      {showCorrectAnswer && submitted && (
        <p className={styles.acceptableResponses}>
          {question.exactResponse ? (
            <Label>Acceptable response (must contain all words)</Label>
          ) : (
            <Label>Acceptable responses</Label>
          )}
          {': '}
          {_.map(question.acceptableResponses, (r) => r.text).join(', ')}
        </p>
      )}
    </div>
  );
}

export default Essay;
